<template>
  <div ref="opData" id="opData" :class="activateComparison ? 'dataTables activateComparison' : 'dataTables'">
    <el-table ref="opCoderTable" v-if="grouping === '1'" key="byCoderOp" :data="isIE11 ? coderTablePagination : coderTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`ambCoder_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambCoder', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.coder)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodesAmb" v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoder_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambCoder', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoder_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambCoder', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_pcsCodes_${scope.$index} details`"
            @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions,  {table: 'opCoder', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoder_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambCoder', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambFacility', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoder_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambCoder', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_emCodes_${scope.$index} details`"
            @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions,  {table: 'opCoder', prop: 'emCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_iiCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'opCoder', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_siCodes_${scope.$index} details`"
            @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions,  {table: 'opCoder', prop: 'siCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambCoder_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambCoder', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opCoderTrendingTable" v-if="grouping === '16'" key="byCoderOp" :data="isIE11 ? coderTrendingTablePagination : coderTrendingTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <!-- <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`opCoderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opCoder', prop: 'coder', index: scope.$index, row: scope.row }, $event)"></div> -->
          <div v-html="highlightValue(scope.row.coder, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :class="`ambCoderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambCoderTrending', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.projectName)" v-html="highlightValue(scope.row.projectName, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodesAmb" v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoderTrending_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambCoderTrending', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoderTrending_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambCoderTrending', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_pcsCodes_${scope.$index} details`"
            @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions,  {table: 'opCoder', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoderTrending_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambCoderTrending', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoderTrending_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambCoderTrending', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambCoderTrending_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambCoderTrending', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_emCodes_${scope.$index} details`"
            @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions,  {table: 'opCoder', prop: 'emCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_iiCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'opCoder', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_siCodes_${scope.$index} details`"
            @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions,  {table: 'opCoder', prop: 'siCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambCoderTrending_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambCoderTrending', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opPatientTypeTable" v-if="grouping === '3'" key="byPatTypeOp" :data="isIE11 ? patientTypeTablePagination : patientTypeTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patTypeDesc" label="Patient Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.patTypeDesc" v-html="highlightValue(scope.row.patTypeDesc, filterCriteria)" :class="`ambcode_patTypeDesc_${scope.$index} details`" @click="buildPivotDataStats('Patient Type Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambcode', prop: 'patTypeDesc', index: scope.$index, row: scope.row }, $event, scope.row.patTypeDesc)"></div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Patient Type ${scope.row.patTypeDesc}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcode_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambcode', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcode_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambcode', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`ambcode_pcsCodes_${scope.$index} details`"
            @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions,  {table: 'ambcode', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcode_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambcode', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cptCodesWReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambFacility', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodesWOReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcode_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambcode', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue( `${(scope.row.emCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`ambcode_emCodes_${scope.$index} details`"
            @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions,  {table: 'ambcode', prop: 'emCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'emCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue( `${(scope.row.iiCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`ambcode_iiCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'ambcode', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'iiCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'iiCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue( `${(scope.row.siCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`ambcode_siCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'ambcode', prop: 'siCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'siCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'siCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambcode_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambcode', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length" :class="getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="ambFacilityTable" v-if="grouping === '5'" key="byFacilityOp" :data="isIE11 ? facilityTablePagination : facilityTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cliName" label="Facility" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.cliName" v-html="highlightValue(scope.row.cliName, filterCriteria)" :class="`ambFacility_cliName_${scope.$index} details`" @click="buildPivotDataStats('Facility Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambFacility', prop: 'cliName', index: scope.$index, row: scope.row }, $event, scope.row.cliName)"></div>
          <div title="All Ambulatory reviews" v-if="activateComparison && comparisonAccountsAMB.length">
            All Ambulatory reviews
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Facility ${scope.row.cliName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambFacility', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambFacility', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue( `${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_pcsCodes_${scope.$index} details`"
            @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions,  {table: 'ambFacility', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambFacility', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodesWReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambFacility', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodesWOReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambFacility', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_emCodes_${scope.$index} details`"
            @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions,  {table: 'ambFacility', prop: 'emCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'emCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambFacility_iiCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'ambFacility', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'iiCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'iiCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`ambFacility_siCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions,  {table: 'ambFacility', prop: 'siCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'siCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'siCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambFacility_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambFacility', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length" :class="getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="ambProjectTable" v-if="grouping === '18'" key="byProjectAmb" :data="isIE11 ? projectTablePagination : projectTableData" :fit="true" empty-text="No Project Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.projectName" v-html="highlightValue(scope.row.projectName, filterCriteria)" :class="`ambProject_projectName_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambProject', prop: 'projectName', index: scope.$index, row: scope.row }, $event, scope.row.projectName)"></div>
          <div title="All Ambulatory reviews" v-if="activateComparison && comparisonAccountsAMB.length">
            All Ambulatory reviews
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable width="120">
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Project ${scope.row.projectName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambProject_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambProject', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambProject_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambProject', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambProject_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambProject', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cptCodesWReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambProject_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambProject', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cptCodesWOReimb', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambProject_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambProject', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambProject_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambProject', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length" :class="getBedSizeValue('projectName', scope.row.projectName, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opReasonTable" v-if="grouping === '6'" key="byReasonOp" :data="isIE11 ? reasonTablePagination : reasonTableData" :fit="true" empty-text="No Reason Data Available" :summary-method="getSummaries" show-summary :height="400" stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('description', scope.row.description, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Reason" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('description', scope.row.description, 'description', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.number, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`APC Reason ${scope.row.description}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('description', scope.row.description, 'number', scope.row.codeDesc, true) }}
          </div>
        </template>
        <!-- <template slot-scope="scope">
          <div title="View Account Numbers" class="details"
            @click="buildAccountNumbers(`Reason ${scope.row.description}`, scope.row, $event)">
            {{scope.row.number}}
          </div>
        </template> -->
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('description', scope.row.description, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="amt" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.amt), filterCriteria)" :class="`ambReason_amt_${scope.$index} details ${scope.row.amt < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.amt, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambReason', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.amt))">
            {{ moneyFormatter(scope.row.amt) }}
          </div>
          <!-- <span :class="scope.row.amt < 0 ? 'negative' : ''">{{moneyFormatter(scope.row.amt)}}</span> -->
          <div v-if="activateComparison && comparisonAccountsAMB.length" :class="getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opHeaderReasonTable" v-if="grouping === '7'" key="byHeaderReasonOp" :data="isIE11 ? headerReasonTablePagniation : headerReasonTableData" empty-text="No Reason Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="changeReason" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.changeReason" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeReason" label="Reason" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.changeReason, filterCriteria)" :class="`ambheaderreason_changeReason_${scope.$index} details`" @click="buildPivotDataStats('Reason Stats', scope.row.numRecords, scope.row.reimbIncreases, scope.row.reimbDecreases, scope.row.changeReason === 0 ? 0 : scope.row.numRecords, { table: 'ambheaderreason', prop: 'changeReason', index: scope.$index, row: scope.row }, $event, scope.row.changeReason)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeReason', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeDesc" label="Description" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.changeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Reason ${scope.row.changeReason}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambheaderreason_reimbDiff_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbIncreases, scope.row.reimbDecreases, scope.row.recordsWithIncreases, scope.row.recordsWithDecreases, { table: 'ambheaderreason', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length" :class="getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opDxTable" v-if="grouping === '8'" key="byDxOp" :data="isIE11 || isCodeGrouping() ? dxTablePagination : dxTableData" empty-text="No Dx Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambdx_cmCodes_${scope.$index} details`" @click="buildPivotData('Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambdx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opSdohTable" v-if="grouping === '15' || grouping === '19'" :key="grouping === '19' ? 'byPriDxAmb' : 'bySdohOp'" :data="isIE11 || isCodeGrouping() ? sdohTablePagination : sdohTableData" :empty-text="grouping === '19' ? 'No Pri Dx Data Available' : 'No SDOH Dx Data Available'" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`${grouping === '19' ? 'Pri Dx' : 'Dx SDOH'} Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambdx_cmCodes_${scope.$index} details`" @click="buildPivotData(grouping === '19' ? 'Pri Dx Accuracy Rate' : 'SDOH Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, grouping === '19' ? priDxRevisionCount(scope.row) : scope.row.numOfRevisions, { table: 'ambdx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opHccTable" v-if="grouping === '12'" key="byHccOp" :data="isIE11 || isCodeGrouping() ? hccTablePagination : hccTableData" empty-text="No HCC V24 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV24')"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`ambhcc_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V24 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambhcc', prop: 'hccV24AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opHccV28Table" v-if="grouping === '14'" key="byHccV28Op" :data="isIE11 || isCodeGrouping() ? hccV28TablePagination : hccV28TableData" empty-text="No HCC V28 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV28')"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`ambhccv28_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V28 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambhccv28', prop: 'hccV28AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opCptTable" v-if="grouping === '9'" key="byCptOp" :data="isIE11 || isCodeGrouping() ? cptTablePagination : cptTableData" empty-text="No CPT Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`CPT Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWReimb" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcpt_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambcpt', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'cptCodes', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opCptNoReimbTable" v-if="grouping === '13'" key="byCptNoReimb" :data="isIE11 || isCodeGrouping() ? cptTablePaginationNoReimb : cptTableDataNoReimb" empty-text="No CPT Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`CPT Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambcpt_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambcpt', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'cptCodes', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opModTable" v-if="grouping === '10'" key="byModOp" :data="isIE11 ? modTablePagination : modTableData" empty-text="No MOD Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable>
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`MOD Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="Accuracy Rate" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('mod modCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambmod_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambmod', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'modCodes', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opPxTable" v-if="grouping === '11'" key="byPxOp" :data="isIE11 || isCodeGrouping() ? pxTablePagination : pxTableData" empty-text="No Px Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsAMB.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Ambulatory reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Px Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambpx_pcsCodes_${scope.$index} details`" @click="buildPivotData('Px Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ambpx', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsAMB.length">
            {{ getBedSizeValue('code', scope.row.code, 'pcsCodes', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opServiceLineTable" v-if="grouping === '17'" key="byServiceLineOp" :data="isIE11 ? serviceLineTablePagination : serviceLineTableData" empty-text="No Service Line Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="clientServiceLineName" label="Service Line" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.clientServiceLineName, filterCriteria)" :class="`ambServiceLine_clientServiceLineName_${scope.$index} details`" @click="buildPivotDataStats('Service Line Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'ambServiceLine', prop: 'clientServiceLineName', index: scope.$index, row: scope.row }, $event, scope.row.clientServiceLineName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodesAmb" v-html="highlightValue(`${(scope.row.totalCodesAmb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambServiceLine_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.asc_numCptReimbNoRec + scope.row.asc_numCptNoReimbNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.asc_numCptReimbAdditions + scope.row.asc_numCptNoReimbAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.asc_numCptReimbDeletions + scope.row.asc_numCptNoReimbDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.asc_numCptReimbRevisions + scope.row.asc_numCptNoReimbRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'ambServiceLine', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodesAmb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambServiceLine_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'ambServiceLine', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_pcsCodes_${scope.$index} details`"
            @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions,  {table: 'opCoder', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="cptCodesWReimb" label="CPT with Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT with Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambServiceLine_cptCodesWReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptReimbNoRec, scope.row.asc_numCptReimbAdditions, scope.row.asc_numCptReimbDeletions, scope.row.asc_numCptReimbRevisions, { table: 'ambServiceLine', prop: 'cptCodesWReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodesWOReimb" label="CPT w/o Reimb." sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT without Reimb.', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`, filterCriteria)" :class="`ambServiceLine_cptCodesWOReimb_${scope.$index} details`" @click="buildPivotData('CPT with Reimb.', scope.row.asc_numCptNoReimbNoRec, scope.row.asc_numCptNoReimbAdditions, scope.row.asc_numCptNoReimbDeletions, scope.row.asc_numCptNoReimbRevisions, { table: 'ambServiceLine', prop: 'cptCodesWOReimb', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodesWOReimb * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`ambServiceLine_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'ambServiceLine', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_emCodes_${scope.$index} details`"
            @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions,  {table: 'opCoder', prop: 'emCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_iiCodes_${scope.$index} details`"
            @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions,  {table: 'opCoder', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%` , filterCriteria)" :class="`opCoder_siCodes_${scope.$index} details`"
            @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions,  {table: 'opCoder', prop: 'siCodes', index: scope.$index, row: scope.row }, $event)">
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`ambServiceLine_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'ambServiceLine', prop: 'ambFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>

    <div class="qmDisclaimer priDxDisclaimer" v-if="isPriDxGrouping()">Pri Dx revisions include both 'Revised From' and 'Revised To'. A single record can appear under two principal diagnoses, so the total instances can be higher than the number of unique records.</div>
    <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="total, prev, pager, next" :page-size="itemsPerPage" :total="paginationTotal" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-pagination class="pager" v-if="isCodeGrouping()" background :pager-count="15" layout="total, prev, pager, next" :page-size="codeItemsPerPage" :total="paginationTotal" :current-page.sync="currentPage" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-popover ref="opDetailsPopOver" :visible-arrow="false" placement="bottom" width="400" trigger="click" @after-enter="handleHidePopOver">
      <DetailsPopOver :header="header" :popOverData="popOverData" :tableType="tableType" :reviewType="reviewType" :row="row" :rowMeta="rowMeta" :isOpen="isOpen" @tableTypeChange="handleTableTypeChange" @headerChange="header = $event"> </DetailsPopOver>
    </el-popover>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import hiaFilters from '@/mixins/hiaFilters'
import DetailsPopOver from '@/views/Dashboards/DetailsPopOver'
import { shouldDismissDashboardPopover, patchPopoverDocumentClick } from '@/utilities/dashboardPopoverDismiss'
import { mapState, mapActions, mapMutations } from 'vuex'
import { format, parseISO } from 'date-fns'

export default {
  data: function() {
    return {
      header: '',
      popperClickTarget: undefined,
      popOverData: [],
      tableType: '',
      reviewType: 'op',
      row: {},
      rowMeta: {},
      isOpen: false,
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true,
      codeItemsPerPage: 60,
      sortProp: '',
      sortOrder: ''
    }
  },
  name: 'AmbulatoryTables',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    codeTypeGrouping: { type: Array },
    dropdown: { type: Array },
    filterCriteria: { type: String },
    selectedGrouping: { type: Array },
    activateComparison: { type: Boolean },
    bedSize: { type: String }
  },
  components: {
    DetailsPopOver
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    ...mapMutations('dashboard/', ['CLEAR_DASHBOARD_ACCOUNTS']),
    handleTableTypeChange(newType) {
      this.tableType = newType
      if (newType === 'accountNumbers') {
        this.$nextTick(() => {
          this.$refs.opDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      }
    },
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    getTableData(grouping) {
      if (!this.reviewDashboardData) {
        return []
      }

      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null && this.reviewDashboardData[opIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[opIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.codeTypeGrouping.length) {
          data = data.filter(x => {
            let val
            this.codeTypeGrouping.forEach(y => {
              if (x.codeDesc === y) {
                val = x
              }
            })
            return val
          })
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    buildPivotData(header, noRecs, adds, dels, revs, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'stats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Total Reviewed', value: noRecs + adds + dels + revs }, { title: 'Total Recommendations', value: adds + dels + revs }, { title: '', value: '' }, { title: 'No Recommendations', value: noRecs }, { title: 'Additions', value: adds }, { title: 'Deletions', value: dels }]
        // include revisions line for all except HCC
        if (!(row.table && (row.table === 'ambhcc' || row.table === 'ambhccv28'))) {
          this.popOverData.push({ title: 'Revisions', value: revs })
        }
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataStats(header, totalRecords, reimbInc, reimbDec, recordsWithRecommendations, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'dataStats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Number of Records', value: totalRecords }, { title: 'Record Recommendations', value: recordsWithRecommendations }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }]
        this.rowMeta = {
          table: row.table,
          prop: 'mainDashboardGrouping',
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataFinancials(header, financialImpact, reimbInc, reimbDec, reimbIncRecords, reimbDecRecords, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'financial'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Financial Impact', value: financialImpact }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }, { title: 'Reimbursement Decrease Records', value: reimbDecRecords }, { title: 'Reimbursement Increase Records', value: reimbIncRecords }]
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildDxPopover(title, row, e, hccVersion) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'dxDashboard'
        this.header = `HCC ${title}`
        this.popOverData = []
        this.row = row
        this.row.hccVersion = hccVersion
        this.handleShowDetailsPopover(e.target)
      })
    },
    buildAccountNumbers(title, row, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = title
        this.popOverData = []
        this.row = row
        this.handleShowDetailsPopover(e.target)
      })
    },
    getSummaryData() {
      let data = this.isIE11 ? this.paginationSummaries : []
      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }
      if (!data || !data.length) {
        switch (this.grouping) {
          case '1': data = this.coderTableData; break
          case '16': data = this.coderTrendingTableData; break
          case '3': data = this.patientTypeTableData; break
          case '5': data = this.facilityTableData; break
          case '18': data = this.projectTableData; break
          case '6': data = this.reasonTableData; break
          case '7': data = this.headerReasonTableData; break
          case '8': data = this.dxTableData; break
          case '15': data = this.sdohTableData; break
          case '19': data = this.sdohTableData; break
          case '9': data = this.cptTableData; break
          case '13': data = this.cptTableDataNoReimb; break
          case '10': data = this.modTableData; break
          case '11': data = this.pxTableData; break
          case '12': data = this.hccTableData; break
          case '14': data = this.hccV28TableData; break
          case '17': data = this.serviceLineTableData; break
        }
      }
      return data || []
    },
    isPriDxGrouping() {
      return this.grouping === '19'
    },
    priDxRevisionCount(row) {
      const fromVal = row.numOfRevisedFrom != null ? row.numOfRevisedFrom : row.revisedFromCount
      const toVal = row.numOfRevisedTo != null ? row.numOfRevisedTo : row.revisedToCount
      const from = Number(fromVal)
      const to = Number(toVal)
      return (isNaN(from) ? 0 : from) + (isNaN(to) ? 0 : to)
    },
    buildSummaryPivotData(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const sum = (field) => data.reduce((t, r) => t + (isNaN(Number(r[field])) ? 0 : r[field]), 0)
      let allAccountNumbers = data.map(r => r.accountNumbers).filter(a => a).join(',')
      const fakeRow = { table: 'summary', prop: columnProperty, row: { accountNumbers: allAccountNumbers } }

      switch (columnProperty) {
        case 'totalCodes': {
          let noRecs = sum('dxNoRec') + sum('pxNoRec') + sum('asc_numCptReimbNoRec') + sum('asc_numCptNoReimbNoRec') + sum('modNoRec') + sum('emNoRec') + sum('iiNoRec') + sum('siNoRec')
          let adds = sum('dxAdditions') + sum('pxAdditions') + sum('asc_numCptReimbAdditions') + sum('asc_numCptNoReimbAdditions') + sum('modAdditions') + sum('emAdditions') + sum('iiAdditions') + sum('siAdditions')
          let dels = sum('dxDeletions') + sum('pxDeletions') + sum('asc_numCptReimbDeletions') + sum('asc_numCptNoReimbDeletions') + sum('modDeletions') + sum('emDeletions') + sum('iiDeletions') + sum('siDeletions')
          let revs = sum('dxRevisions') + sum('pxRevisions') + sum('asc_numCptReimbRevisions') + sum('asc_numCptNoReimbRevisions') + sum('modRevisions') + sum('emRevisions') + sum('iiRevisions') + sum('siRevisions')
          let tcRow = { table: 'summary', prop: 'opTotalCodes', row: { accountNumbers: allAccountNumbers } }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('Total Codes', noRecs, adds, dels, revs, tcRow, { target: targetElement }, displayValue)
          break
        }
        case 'cmCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '8' || this.grouping === '15' || this.grouping === '19') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = this.isPriDxGrouping() ? data.reduce((t, r) => t + this.priDxRevisionCount(r), 0) : sum('numOfRevisions'); label = this.grouping === '19' ? 'Pri Dx Accuracy Rate' : this.grouping === '15' ? 'SDOH Dx Accuracy Rate' : 'Dx Accuracy Rate'
          } else {
            noRecs = sum('dxNoRec'); adds = sum('dxAdditions'); dels = sum('dxDeletions'); revs = sum('dxRevisions'); label = 'ICD-10 CM Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'pcsCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '11') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'Px Accuracy Rate'
          } else {
            noRecs = sum('pxNoRec'); adds = sum('pxAdditions'); dels = sum('pxDeletions'); revs = sum('pxRevisions'); label = 'ICD-10 PCS Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'cptCodesWReimb': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '9') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'CPT Accuracy Rate'
          } else {
            noRecs = sum('asc_numCptReimbNoRec'); adds = sum('asc_numCptReimbAdditions'); dels = sum('asc_numCptReimbDeletions'); revs = sum('asc_numCptReimbRevisions'); label = 'CPT with Reimb.'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'cptCodesWOReimb': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '13') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'CPT Accuracy Rate'
          } else {
            noRecs = sum('asc_numCptNoReimbNoRec'); adds = sum('asc_numCptNoReimbAdditions'); dels = sum('asc_numCptNoReimbDeletions'); revs = sum('asc_numCptNoReimbRevisions'); label = 'CPT without Reimb.'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'modCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '10') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'MOD Accuracy Rate'
          } else {
            noRecs = sum('modNoRec'); adds = sum('modAdditions'); dels = sum('modDeletions'); revs = sum('modRevisions'); label = 'MOD Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'emCodes': {
          let noRecs = sum('emNoRec'); let adds = sum('emAdditions'); let dels = sum('emDeletions'); let revs = sum('emRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('E/M Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'iiCodes': {
          let noRecs = sum('iiNoRec'); let adds = sum('iiAdditions'); let dels = sum('iiDeletions'); let revs = sum('iiRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('I&I Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'siCodes': {
          let noRecs = sum('siNoRec'); let adds = sum('siAdditions'); let dels = sum('siDeletions'); let revs = sum('siRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('S&I Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'financialImpact': {
          let fiRow = { table: 'summary', prop: 'ambFinancialImpact', row: { accountNumbers: allAccountNumbers } }
          let financialImpact = sum('financialImpact')
          let displayValue = this.moneyFormatter(financialImpact)
          this.buildPivotDataFinancials('Financial Stats', financialImpact, sum('reimbInc'), sum('reimbDec'), sum('reimbIncRecords'), sum('reimbDecRecords'), fiRow, { target: targetElement }, displayValue)
          break
        }
        case 'amt': {
          let amtRow = { table: 'summary', prop: 'ambFinancialImpact', row: { accountNumbers: allAccountNumbers } }
          let amt = sum('amt')
          let displayValue = this.moneyFormatter(amt)
          this.buildPivotDataFinancials('Financial Stats', amt, sum('reimbInc'), sum('reimbDec'), sum('reimbIncRecords'), sum('reimbDecRecords'), amtRow, { target: targetElement }, displayValue)
          break
        }
        case 'accuracyRate': {
          let dimension = this.grouping === '14' ? 'hccV28AccuracyRate' : 'hccV24AccuracyRate'
          let hccLabel = this.grouping === '14' ? 'HCC V28 Accuracy Rate' : 'HCC V24 Accuracy Rate'
          let hccFakeRow = { table: 'summary', prop: dimension, row: { accountNumbers: allAccountNumbers } }
          let noRecs = sum('numOfNoRec'); let adds = sum('numOfAdditions'); let dels = sum('numOfDeletions'); let revs = sum('numOfRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(hccLabel, noRecs, adds, dels, revs, hccFakeRow, { target: targetElement }, displayValue)
          break
        }
      }
    },
    buildSummaryAccountNumbers(targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return
      let allAccountNumbers = data
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      if (!allAccountNumbers) return
      let syntheticRow = { accountNumbers: allAccountNumbers }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = 'Total Instances'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    getActiveTableRef() {
      const map = {
        '1': 'opCoderTable',
'16': 'opCoderTrendingTable',
'3': 'opPatientTypeTable',
        '5': 'ambFacilityTable',
        '18': 'ambProjectTable',
'6': 'opReasonTable',
'7': 'opHeaderReasonTable',
        '8': 'opDxTable',
'15': 'opSdohTable',
'19': 'opSdohTable',
'9': 'opCptTable',
        '13': 'opCptNoReimbTable',
'10': 'opModTable',
'11': 'opPxTable',
        '12': 'opHccTable',
'14': 'opHccV28Table',
'17': 'opServiceLineTable'
      }
      return map[this.grouping] || null
    },
    attachSummaryClickHandlers() {
      this.cleanupSummaryHandlers()

      let tableRef = this.getActiveTableRef()
      if (!tableRef || !this.$refs[tableRef]) return

      let tableEl = this.$refs[tableRef].$el
      let footerWrapper = tableEl.querySelector('.el-table__footer-wrapper')
      if (!footerWrapper) return

      let footerCells = footerWrapper.querySelectorAll('td')
      let table = this.$refs[tableRef]
      let columns = table.columns || []

      const clickableColumns = [
        'totalRecords', 'numRecords', 'number',
        'totalCodes', 'cmCodes', 'pcsCodes', 'cptCodesWReimb', 'cptCodesWOReimb',
        'modCodes', 'emCodes', 'iiCodes', 'siCodes',
        'financialImpact', 'amt', 'accuracyRate'
      ]

      footerCells.forEach((td, index) => {
        if (index >= columns.length) return
        let colProp = columns[index].property
        if (clickableColumns.includes(colProp)) {
          let cellText = td.textContent.trim()
          if (!cellText || cellText === 'N/A' || cellText === '' || cellText === '—') return

          td.classList.add('details')
          let handler = (e) => {
            e.stopPropagation()
            if (colProp === 'totalRecords' || colProp === 'numRecords' || colProp === 'number') {
              this.buildSummaryAccountNumbers(td)
            } else {
              this.buildSummaryPivotData(colProp, td)
            }
          }
          td.addEventListener('click', handler)
          this._summaryHandlers.push({ el: td, handler: handler })
        }
      })
    },
    cleanupSummaryHandlers() {
      if (this._summaryHandlers) {
        this._summaryHandlers.forEach(({ el, handler }) => {
          el.removeEventListener('click', handler)
          el.classList.remove('details')
        })
      }
      this._summaryHandlers = []
    },
    handleShowDetailsPopover(clickTarget) {
      let popper = this.$refs.opDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = clickTarget
        let reference = document.querySelector('#reviewDashboard')
        popper.doDestroy()
        popper.referenceElm = reference
        this.isOpen = true
        popper.$refs.popper.classList.add('largeCenterPopOver')
        popper.doShow()
        this.$nextTick(() => {
          this.$refs.opDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      })
    },
    handleShowPopOver(row, targetElement) {
      let popper = this.$refs.opDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = targetElement || document.querySelector(`.${row.table}_${row.prop}_${row.index}`)
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
        this.$nextTick(() => {
          this.$refs.opDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      })
    },
    handleHidePopOver() {
      let popper = this.$refs.opDetailsPopOver
      patchPopoverDocumentClick(popper)
      const handler = e => {
        if (shouldDismissDashboardPopover(e, popper, this.popperClickTarget)) {
          this.CLEAR_DASHBOARD_ACCOUNTS()
          this.isOpen = false
          popper.doClose()
          popper.doDestroy()
          this.clearClass()
          document.removeEventListener('click', handler, false)
        }
      }
      document.addEventListener('click', handler, false)
    },
    clearPopOverData() {
      this.CLEAR_DASHBOARD_ACCOUNTS()
      this.tableType = ''
      this.header = ''
      this.popOverData = []
      this.row = {}
      this.isOpen = false
    },
    clearClass() {
      let popper = this.$refs.opDetailsPopOver
      if (popper) {
        popper.$refs.popper.classList.remove('largeCenterPopOver')
      }
    },
    getAPCSummary(param) {
      let { columns, data } = param
      const sums = []

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
            sums[index] = ''
            break
          case 'apc':
            sums[index] = ''
            break
          case 'patType':
            sums[index] = ''
            break
          case 'financialImpact':
            let value = this.totalMoneySummary(column.property, data, index)
            let td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'n/a'
        }
      })

      return sums
    },
    getSummaries(param) {
      let { columns, data } = param
      const sums = []
      let value
      let td

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
          case 'coder':
          case 'description':
          case 'patTypeDesc':
          case 'apc':
          case 'drName':
          case 'cliName':
          case 'projectName':
          case 'projectStartDate':
          case 'changeReason':
          case 'changeDesc':
          case 'code':
            if (index === 0 || (this.activateComparison && this.comparisonAccountsAMB.length && index === 1)) {
              sums[index] = 'Total'
            } else {
              sums[index] = ''
            }
            break
          case 'numRecords':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'totalRecords':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'totalOccurrences':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'number':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'accuracyRate':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'totalCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cmCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'pcsCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cptCodesWReimb':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cptCodesWOReimb':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'modCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'emCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'iiCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'siCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'financialImpact':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            if (this.grouping !== '7') {
              sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            } else {
              sums[index] = value
            }
            break
          case 'amt':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'N/A'
        }
      })

      return sums
    },
    totalPercentSummaries(column, data, index, columnArray) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // totalCodes Summary
        if (column === 'totalCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions'])) || !isNaN(Number(data[i]['asc_numCptReimbNoRec'])) || !isNaN(Number(data[i]['asc_numCptReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptReimbRevisions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbNoRec'])) || !isNaN(Number(data[i]['asc_numCptNoReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbRevisions'])) || !isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions'])) || !isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions'])) || !isNaN(Number(data[i]['iiNoRec'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions'])) || !isNaN(Number(data[i]['siNoRec'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions'] + data[i]['asc_numCptReimbNoRec'] + data[i]['asc_numCptReimbAdditions'] + data[i]['asc_numCptReimbDeletions'] + data[i]['asc_numCptReimbRevisions'] + data[i]['asc_numCptNoReimbNoRec'] + data[i]['asc_numCptNoReimbAdditions'] + data[i]['asc_numCptNoReimbDeletions'] + data[i]['asc_numCptNoReimbRevisions'] + data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions'] + data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['iiNoRec'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions'] + data[i]['siNoRec'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions'])) || !isNaN(Number(data[i]['asc_numCptReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptReimbRevisions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbRevisions'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions'] + data[i]['asc_numCptReimbAdditions'] + data[i]['asc_numCptReimbDeletions'] + data[i]['asc_numCptReimbRevisions'] + data[i]['asc_numCptNoReimbAdditions'] + data[i]['asc_numCptNoReimbDeletions'] + data[i]['asc_numCptNoReimbRevisions'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }
        }

        // cmCodes Summary
        if (column === 'cmCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }
        }

        // pcsCodes Summary
        if (column === 'pcsCodes') {
          if (!isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            mt += data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }

          if (!isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            adr += data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }
        }

        // cptCodesWReimb
        if (column === 'cptCodesWReimb') {
          if (!isNaN(Number(data[i]['asc_numCptReimbNoRec'])) || !isNaN(Number(data[i]['asc_numCptReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptReimbRevisions']))) {
            mt += data[i]['asc_numCptReimbNoRec'] + data[i]['asc_numCptReimbAdditions'] + data[i]['asc_numCptReimbDeletions'] + data[i]['asc_numCptReimbRevisions']
          }

          if (!isNaN(Number(data[i]['asc_numCptReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptReimbRevisions']))) {
            adr += data[i]['asc_numCptReimbAdditions'] + data[i]['asc_numCptReimbDeletions'] + data[i]['asc_numCptReimbRevisions']
          }
        }

        // cptCodesWReimb
        if (column === 'cptCodesWOReimb') {
          if (!isNaN(Number(data[i]['asc_numCptNoReimbNoRec'])) || !isNaN(Number(data[i]['asc_numCptNoReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbRevisions']))) {
            mt += data[i]['asc_numCptNoReimbNoRec'] + data[i]['asc_numCptNoReimbAdditions'] + data[i]['asc_numCptNoReimbDeletions'] + data[i]['asc_numCptNoReimbRevisions']
          }

          if (!isNaN(Number(data[i]['asc_numCptNoReimbAdditions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbDeletions'])) || !isNaN(Number(data[i]['asc_numCptNoReimbRevisions']))) {
            adr += data[i]['asc_numCptNoReimbAdditions'] + data[i]['asc_numCptNoReimbDeletions'] + data[i]['asc_numCptNoReimbRevisions']
          }
        }

        // modCodes
        if (column === 'modCodes') {
          if (!isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            mt += data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }

          if (!isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            adr += data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }
        }

        // emCodes
        if (column === 'emCodes') {
          if (!isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            mt += data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }

          if (!isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            adr += data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }
        }

        // iiCodes
        if (column === 'iiCodes') {
          if (!isNaN(Number(data[i]['iiNoRec'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            mt += data[i]['iiNoRec'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }

          if (!isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            adr += data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }
        }

        // siCodes
        if (column === 'siCodes') {
          if (!isNaN(Number(data[i]['siNoRec'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            mt += data[i]['siNoRec'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }

          if (!isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            adr += data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }
        }

        // dx table accuracy rate
        if (columnArray.label === 'Accuracy Rate') {
          const revisions = this.isPriDxGrouping() ? this.priDxRevisionCount(data[i]) : (isNaN(Number(data[i]['numOfRevisions'])) ? 0 : data[i]['numOfRevisions'])
          if (!isNaN(Number(data[i]['numOfNoRec'])) || !isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || revisions) {
            mt += data[i]['numOfNoRec'] + data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + revisions
          }

          if (!isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || revisions) {
            adr += data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + revisions
          }
        }
      }

      return mt || adr ? this.calculatePercentages(mt, adr) : 'N/A'
    },
    totalSummary(column, data, index) {
      // let groupValue = this.dropdown.filter(x => x.key === this.grouping)[0]
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)

      return response
    },
    totalMoneySummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)
      return this.moneyFormatter(response)
    },
    calculatePercentages(masterTotal, adrTotal) {
      let response = masterTotal === null || masterTotal === 0 ? 0 : 1 - adrTotal / masterTotal
      return `${(response * 100).toFixed(2)}%`
    },
    checkPercentValues(column, scope, table) {
      let response = false
      switch (column) {
        case 'Total APC':
          if (table === 'apc') {
            if (!scope.row.noRec && !scope.row.additions && !scope.row.deletions && !scope.row.revisions) {
              response = true
            }
          } else {
            if (!scope.row.apcNoRec && !scope.row.apcAdditions && !scope.row.apcDeletions && !scope.row.apcRevisions) {
              response = true
            }
          }
          break
        case 'Total Codes':
          if (!scope.row.dxNoRec && !scope.row.pxNoRec && !scope.row.asc_numCptReimbNoRec && !scope.row.asc_numCptNoReimbNoRec && !scope.row.modNoRec && !scope.row.emNoRec && !scope.row.iiNoRec && !scope.row.siNoRec && !scope.row.dxAdditions && !scope.row.pxAdditions && !scope.row.asc_numCptReimbAdditions && !scope.row.asc_numCptNoReimbAdditions && !scope.row.modAdditions && !scope.row.emAdditions && !scope.row.iiAdditions && !scope.row.siAdditions && !scope.row.dxDeletions && !scope.row.pxDeletions && !scope.row.asc_numCptReimbDeletions && !scope.row.asc_numCptNoReimbDeletions && !scope.row.modDeletions && !scope.row.emDeletions && !scope.row.iiDeletions && !scope.row.siDeletions && !scope.row.dxRevisions && !scope.row.pxRevisions && !scope.row.asc_numCptReimbRevisions && !scope.row.asc_numCptNoReimbRevisions && !scope.row.modRevisions && !scope.row.emRevisions && !scope.row.iiRevisions && !scope.row.siRevisions) {
            response = true
          }
          break
        case 'ICD-10 CM Codes':
          if (!scope.row.dxNoRec && !scope.row.dxAdditions && !scope.row.dxDeletions && !scope.row.dxRevisions) {
            response = true
          }
          break
        case 'ICD-10 PCS Codes':
          if (!scope.row.pxNoRec && !scope.row.pxAdditions && !scope.row.pxDeletions && !scope.row.pxRevisions) {
            response = true
          }
          break
        case 'CPT with Reimb.':
          if (!scope.row.asc_numCptReimbNoRec && !scope.row.asc_numCptReimbAdditions && !scope.row.asc_numCptReimbDeletions && !scope.row.asc_numCptReimbRevisions) {
            response = true
          }
          break
        case 'CPT without Reimb.':
          if (!scope.row.asc_numCptNoReimbNoRec && !scope.row.asc_numCptNoReimbAdditions && !scope.row.asc_numCptNoReimbDeletions && !scope.row.asc_numCptNoReimbRevisions) {
            response = true
          }
          break
        case 'MOD Codes':
          if (!scope.row.modNoRec && !scope.row.modAdditions && !scope.row.modDeletions && !scope.row.modRevisions) {
            response = true
          }
          break
        case 'E/M Codes':
          if (!scope.row.emNoRec && !scope.row.emAdditions && !scope.row.emDeletions && !scope.row.emRevisions) {
            response = true
          }
          break
        case 'I&I Codes':
          if (!scope.row.iiNoRec && !scope.row.iiAdditions && !scope.row.iiDeletions && !scope.row.iiRevisions) {
            response = true
          }
          break
        case 'S&I Codes':
          if (!scope.row.siNoRec && !scope.row.siAdditions && !scope.row.siDeletions && !scope.row.siRevisions) {
            response = true
          }
          break
        case 'dx cmCodes':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec && !scope.row.numOfRevisions) {
            response = true
          }
          break
      }

      return response
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    sortData(data) {
      if (!this.sortProp || !this.sortOrder) return data
      const sorted = [...data]
      const modifier = this.sortOrder === 'ascending' ? 1 : -1
      sorted.sort((a, b) => {
        const valA = a[this.sortProp]
        const valB = b[this.sortProp]
        if (valA == null && valB == null) return 0
        if (valA == null) return 1
        if (valB == null) return -1
        if (typeof valA === 'string') return valA.localeCompare(valB) * modifier
        return (valA - valB) * modifier
      })
      return sorted
    },
    getBedSizeValue(groupKey, value, prop, codeType, allData, patType = null, table = '') {
      // console.log(this.comparisonAccountsAMB)
      //                  groupKey   value              prop              codeType            addData
      //  getBedSizeValue('cliName', scope.row.cliName, 'cptCodesWReimb', scope.row.codeDesc, false) i

      //    getBedSizeValue('code', scope.row.code, 'cptCodes', scope.row.codeDesc, true, null, 'cpt')

      let response = '—'
      if (this.comparisonAccountsAMB.length) {
        let index

        switch (table) {
          case 'dx':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By Dx') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By Dx')
            break
          case 'sdoh':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === (this.grouping === '19' ? 'By Pri Dx' : 'By SDOH Dx')) : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === (this.grouping === '19' ? 'By Pri Dx' : 'By SDOH Dx'))
            break
          case 'hcc':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By HCC') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By HCC')
            break
          case 'hccv28':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By HCC V28') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By HCC V28')
            break
          case 'px':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By Px') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By Px')
            break
          case 'cpt':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By CPT') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By CPT')
            break
          case 'cptCodesWReimb':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By CPT') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By CPT')
            break
          case 'cptCodesWOReimb':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By CPT No Reimb') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By CPT')
            break
          case 'cptCodes':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By CPT') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By CPT')
            break
          case 'mod':
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review' && x.title === 'By MOD') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review' && x.title === 'By MOD')
            break
          default:
            index = allData ? this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory all review') : this.comparisonAccountsAMB.findIndex(x => x.groupKey === groupKey && x.type === 'ambulatory bedsize review')
        }

        if (index !== -1) {
          let found = {}
          if (groupKey === 'cliName' || groupKey === 'projectName') {
            found = this.comparisonAccountsAMB[index].data.find(x => x.codeDesc === codeType)
          } else {
            found = patType === null ? this.comparisonAccountsAMB[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType) : this.comparisonAccountsAMB[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType && x.patType === patType)
          }
          if (found) {
            let percents = ['totalCodes', 'cmCodes', 'pcsCodes', 'cptCodes', 'cptCodesWReimb', 'cptCodesWOReimb', 'modCodes', 'emCodes', 'iiCodes', 'siCodes', 'accuracyRate']
            let money = ['financialImpact', 'amt']
            response = found[prop]
            // display formats
            if (percents.some(x => x === prop)) {
              response = `${(found[prop] * 100).toFixed(2)}%`
            }

            if (money.some(x => x === prop)) {
              response = this.moneyFormatter(found[prop])
            }
          }
          return response
        }
      }
      return response
    },
    isCodeGrouping() {
      return false
    },
    convertHccs(delimited) {
      if (delimited) {
        let retArray = delimited.split('-')
        if (retArray) {
          return retArray
        }
      }
      return []
    },
    getHccTitle(id) {
      if (id) {
        let data = []
        let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
        let grouping = 'HCCs'
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        let filteredList = data.filter(a => a.hccId === id)
        if (filteredList[0]) {
          return filteredList[0].description
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }
  },
  created: function() {
    this._summaryHandlers = []
  },
  mounted() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  updated() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  beforeDestroy() {
    this.cleanupSummaryHandlers()
  },
  watch: {
    grouping() {
      this.currentPage = 1
      this.sortProp = ''
      this.sortOrder = ''
    },
    reviewDashboardData: {
      handler() {
        this.$nextTick(() => {
          let tableRef = this.getActiveTableRef()
          if (tableRef && this.$refs[tableRef]) {
            this.$refs[tableRef].doLayout()
          }
          this.$nextTick(() => {
            this.attachSummaryClickHandlers()
          })
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccountsAMB']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    apcTableData() {
      return this.getTableData('By APC')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    projectTableData() {
      return this.getTableData('By Project')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    headerReasonTableData() {
      return this.getTableData('By Header Reason')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData(this.grouping === '19' ? 'By Pri Dx' : 'By SDOH Dx')
    },
    cptTableData() {
      return this.getTableData('By CPT')
    },
    cptTableDataNoReimb() {
      return this.getTableData('By CPT No Reimb')
    },
    modTableData() {
      return this.getTableData('By MOD')
    },
    pxTableData() {
      return this.getTableData('By Px')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    },
    coderTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTableData.slice(from, to)
    },
    coderTrendingTablePagination() {
      let length = this.coderTrendingTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTrendingTableData.slice(from, to)
    },
    patientTypeTablePagination() {
      let length = this.patientTypeTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.patientTypeTableData.slice(from, to)
    },
    apcTableDataPagination() {
      let length = this.apcTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.apcTableData.slice(from, to)
    },
    facilityTablePagination() {
      let length = this.facilityTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.facilityTableData.slice(from, to)
    },
    projectTablePagination() {
      let length = this.projectTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.projectTableData.slice(from, to)
    },
    reasonTablePagination() {
      let length = this.reasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.reasonTableData.slice(from, to)
    },
    headerReasonTablePagniation() {
      let length = this.headerReasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.headerReasonTableData.slice(from, to)
    },
    dxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.dxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.dxTableData).slice(from, to)
    },
    sdohTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.sdohTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.sdohTableData).slice(from, to)
    },
    hccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccTableData).slice(from, to)
    },
    hccV28TablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccV28TableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccV28TableData).slice(from, to)
    },
    cptTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.cptTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.cptTableData).slice(from, to)
    },
    cptTablePaginationNoReimb() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.cptTableDataNoReimb.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.cptTableDataNoReimb).slice(from, to)
    },
    modTablePagination() {
      let length = this.modTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.modTableData.slice(from, to)
    },
    pxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.pxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.pxTableData).slice(from, to)
    },
    serviceLineTablePagination() {
      let length = this.serviceLineTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.serviceLineTableData.slice(from, to)
    },
    paginationTotal() {
      let length = 0
      switch (this.grouping) {
        case '1':
          length = this.coderTableData.length
          break
        case '16':
          length = this.coderTrendingTableData.length
          break
        case '2':
          length = this.apcTableData.length
          break
        case '3':
          length = this.patientTypeTableData.length
          break
        case '5':
          length = this.facilityTableData.length
          break
        case '18':
          length = this.projectTableData.length
          break
        case '6':
          length = this.reasonTableData.length
          break
        case '7':
          length = this.headerReasonTableData.length
          break
        case '8':
          length = this.dxTableData.length
          break
        case '15':
          length = this.sdohTableData.length
          break
        case '19':
          length = this.sdohTableData.length
          break
        case '9':
          length = this.cptTableData.length
          break
        case '13':
          length = this.cptTableDataNoReimb.length
          break
        case '10':
          length = this.modTableData.length
          break
        case '11':
          length = this.pxTableData.length
          break
        case '12':
          length = this.hccTableData.length
          break
        case '14':
          length = this.hccV28TableData.length
          break
        case '17':
          length = this.serviceLineTableData.length
          break
      }
      return length
    },
    paginationSummaries() {
      let data = []
      switch (this.grouping) {
        case '1':
          data = this.coderTableData
          break
        case '16':
          data = this.coderTrendingTableData
          break
        case '2':
          data = this.apcTableData
          break
        case '3':
          data = this.patientTypeTableData
          break
        case '5':
          data = this.facilityTableData
          break
        case '18':
          data = this.projectTableData
          break
        case '6':
          data = this.reasonTableData
          break
        case '7':
          data = this.headerReasonTableData
          break
        case '8':
          data = this.dxTableData
          break
        case '15':
          data = this.sdohTableData
          break
        case '19':
          data = this.sdohTableData
          break
        case '9':
          data = this.cptTableData
          break
        case '13':
          data = this.cptTableDataNoReimb
          break
        case '10':
          data = this.modTableData
          break
        case '11':
          data = this.pxTableData
          break
        case '12':
          data = this.hccTableData
          break
        case '14':
          data = this.hccV28TableData
          break
        case '17':
          data = this.serviceLineTableData
          break
      }
      return data
    },
    codeGroupingAllData() {
      let data = []
      switch (this.grouping) {
        case '8':
          data = this.dxTableData
          break
        case '15':
          data = this.dxTableData
          break
        case '19':
          data = this.sdohTableData
          break
        case '9':
          data = this.cptTableData
          break
        case '13':
          data = this.cptTableDataNoReimb
          break
        case '11':
          data = this.pxTableData
          break
        case '12':
          data = this.hccTableData
          break
        case '14':
          data = this.hccV28TableData
          break
      }
      return data
    }
  }
}
</script>

<style scoped>
.qmDisclaimer {
  font-size: 10px;
  font-style: italic;
  margin: 5px 0px 0px 0px;
  color: #909399;
}
.priDxDisclaimer {
  font-size: 11px;
}
/* .negative {
    color: #f56c6c;
  }

  .negative::before {
    content: '(';
  }

  .negative::after {
    content: ')';
  } */

/* Element UI: sort changes header height but does not rerun layout; body-wrapper keeps a stale
   inline height so header + body + summary exceeds fixed height and the footer is clipped. */
#opData >>> .el-table {
  display: flex;
  flex-direction: column;
}
#opData >>> .el-table__header-wrapper,
#opData >>> .el-table__footer-wrapper {
  flex-shrink: 0;
}
#opData >>> .el-table__body-wrapper {
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
}
</style>
